<mat-progress-bar *ngIf="loading.value" mode="indeterminate" />
<mat-card class="cardWithShadow">

    <!-- Skeleton -->
    <div *ngIf="loading.value;" class="p-32">
        <ngx-skeleton-loader count="8" [theme]="{height: '30px'}" />
    </div>

    <!-- No Data -->
    <div *ngIf="!loading.value && !dataLength">
        <app-no-data *ngIf="!dataLength" />
    </div>

    <table mat-table [dataSource]="dataTable.data" matSort
        class="no-wrap m-t-0 v-middle w-100 {{hideData() ? 'd-none' : ''}}">

        <!-- Nome Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <!-- Enabled Column -->
        <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef> Stato </th>
            <td mat-cell *matCellDef="let element"> {{element.enabled}} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Azioni </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button [routerLink]="['/administration/cer/', element.id]"
                    routerLinkActive="router-link-active">
                    <i-tabler name="file-pencil" class="icon-25 text-primary"></i-tabler>
                </button>
                <a (click)="delete(element.id)" matTooltip="Elimina" mat-icon-button class="text-error">
                    <mat-icon>
                        <i-tabler name="trash" />
                    </mat-icon>
                </a>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>

    </table>

    <mat-paginator *ngIf="dataLength && pagination" [pageSizeOptions]="[10, 25, 50]" [length]="dataLength"
        [pageSize]="pageSize" showFirstLastButtons (page)="handlePageEvent($event)" />
</mat-card>

<!-- Row shown when there is no matching data. -->
<ng-template class="mat-row" #matNoDataRow>
    <div colspan="4">Nessun dato per i filtri impostati</div>
</ng-template>